// extracted by mini-css-extract-plugin
module.exports = {"shadow":"footer_shadow__f-EtA","textShadow":"footer_textShadow__1YD5U","container":"footer_container__28DXd","content":"footer_content__o4nWV","next":"footer_next__2rMAW"};